import {
  ChangeDetectionStrategy,
  Component,
  Input,
  HostBinding,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtml } from '@angular/platform-browser';
import { IconService, IconType } from './icon.service';
import { SvgSanitizerService } from './svg-sanitizer.service';
import { SvgValidatorService } from './svg-validator.service';

@Component({
  selector: 'ly-icon',
  standalone: true,
  imports: [CommonModule],
  providers: [IconService, SvgSanitizerService, SvgValidatorService],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input() icon!: IconType | any; // any to avoid type error when using ChannelType
  @Input() size = '18px';

  @HostBinding('style.width') get width() {
    return this.size;
  }
  @HostBinding('style.height') get height() {
    return this.size;
  }

  constructor(private iconService: IconService) {}

  public get svg(): SafeHtml {
    return this.iconService.getSanitizedSvgForName(this.icon);
  }
}
